<template>
    <div class="login">
        <div class="slide-up form-wrapper" style="padding: 0;width:500px;max-height:90vh;overflow:auto;">
            <div style="padding:30px">
                <form v-if="!newLogin" @submit.prevent="submit()">
                    <h3 v-if="hideCompanyInput">{{ companyName }}</h3>
                    <input v-else placeholder="Company Name" type="text" v-model="companyName" />
                    <phone-input v-model="phone" />
                    <input placeholder="Password" type="password" v-model="password" />
                    <input style="margin-bottom:20px" value="Log In" type="submit" placeholder="Submit" :class="submitted ? 'btn disable-button' : 'btn'">
                    <div v-if="loginError" style="color: red;margin-bottom:20px">{{ loginErrorMessage }}</div>
                    <div style="margin-bottom:10px"><a @click.prevent="() => { showPasswordReset = true; }" style="text-decoration:underline;">Forgot your Password?</a></div>
                    <div style="margin-bottom:10px"><a @click.prevent="showRegister()" style="text-decoration:underline;">New User? Register Now</a></div>
                    <router-link v-if="$route.query.redirect" :to="'/admin-login?redirect=' + encodeURIComponent($route.query.redirect)">Admin Login</router-link>
                    <router-link v-else to="/admin-login">Admin Login</router-link>
                </form>
                <form v-else @submit.prevent="submitNew()">
                    <h3>Request to Join<span v-if="hideCompanyInput"> {{ companyName }}</span></h3>
                    <input v-if="!hideCompanyInput" placeholder="Company Name*" type="text" v-model="companyName" @change="getRegistrationForm()" />
                    <phone-input v-model="phone" placeholder="Phone Number*" />
                    <input placeholder="First Name*" type="text" v-model="firstName" />
                    <input placeholder="Last Name*" type="text" v-model="lastName" />
                    <h4 style="margin:0 0 5px;font-size:16px;">Location*</h4>
                    <select v-model="location">
                        <option v-for="(l, i) in locations" :key="i" :value="l">{{ l }}</option>
                    </select>
                    <input type="email" placeholder="Email*" v-model="newEmployeeData.Email" />
                    <template v-for="(field, i) in newEmployeeData.AdditionalFieldsJSON" :key="i">
                        <h4 v-if="field.type == 'date'" style="margin:0 0 5px;font-size:16px;">{{ field.name }}<span v-if="field.requiredOnRegistration">*</span></h4>
                        <input v-if="field.type == 'text'" type="text" :placeholder="field.name + (field.requiredOnRegistration ? '*' : '')" v-model="field.value" />
                        <textarea v-else-if="field.type == 'multitext'" :placeholder="field.name + (field.requiredOnRegistration ? '*' : '')" v-model="field.value"></textarea>
                        <input v-else-if="field.type == 'date'" type="date" v-model="field.value" />
                        <select v-else-if="field.type == 'select'" v-model="field.value">
                            <option :value="undefined" disable>{{ field.name }}*</option>
                            <option v-for="(op, j) in field.options" :key="'op'+j" :value="op">{{ op }}</option>
                        </select>
                    </template>
                    <input placeholder="Password*" type="password" v-model="newPassword" />
                    <input placeholder="Confirm Password*" type="password" v-model="newPasswordConfirm" />
                    <input style="margin-bottom:20px" value="Register" type="submit" placeholder="Submit" :class="submitted ? 'btn disable-button' : 'btn'">
                    <div v-if="loginError" style="color: red;margin-bottom:10px">{{ loginErrorMessage }}</div>
                    <div>Already have an account? <a @click.prevent="showLogIn()" style="text-decoration:underline;">Log In</a></div>
                </form>
            </div>
        </div>
        <div v-html="appHeightOverride"></div>
        <div v-if="registrationSubmitted" class="error-msg-wrap">
            <div class="error-msg">
                <div style="font-size:24px">Your request to join the {{ companyName }} Ironbook has been submitted!</div>
                <div style="margin-top:15px">You will be able to log in once your request has been approved. You can now close this window.</div>
            </div>
        </div>
        <div v-if="showPasswordReset" class="error-msg-wrap">
            <div class="error-msg">
                <div style="font-size:24px">Enter your phone number. If there is an account, you will receive a text message with a link to reset your password.</div>
                <h3 v-if="hideCompanyInput" style="margin-bottom: 15px">{{ companyName }}</h3>
                <div v-else style="margin-bottom: 15px"><input type="text" placeholder="Company" v-model="companyName" /></div>
                <div style="margin-bottom: 15px"><phone-input v-model="phone" /></div>
                <div @click="() => { showPasswordReset = false }" class="btn-invert" style="margin-right:10px">Cancel</div>
                <div @click="submitPasswordReset()" class="btn" style="margin-left:10px">Submit</div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import axios from 'axios';
import { defineComponent, registerRuntimeCompiler } from 'vue';
import PhoneInput from '@/components/PhoneInput.vue';
import { normalizePhone, PHONE_ERROR } from '@/phone';

export default defineComponent({
    name: 'LogIn',
    components: {
        PhoneInput
    },
    data() {
        return {
            hideCompanyInput: false,
            companyName: '',
            phone: '',
            password: '',
            firstName: '',
            lastName: '',
            location: '',
            locations: [] as any,
            newPassword: '',
            newPasswordConfirm: '',
            showPasswordReset: false,
            submitted: false,
            loginError: false,
            loginErrorMessage: 'There was an error',
            appHeightOverride: '<style>#app-main{max-height: 100vh!important}</style>',
            newLogin: false,
            registrationSubmitted: false,
            newEmployeeData: {
                Email: '',
                AdditionalFieldsJSON: [] as any
            }
        }
    },
    async created() {
        if(window.location.href) {
            const companyNameURL = `${this.$store.state.apiUrl}/api/companyconfig/namefromdomain?url=${encodeURIComponent(window.location.href)}`;
            await axios.get(companyNameURL)
                .then(resp => {
                    if(resp?.data?.name) {
                        this.companyName = resp.data.name;
                        this.hideCompanyInput = true;
                    }
                })
                .catch(e => {
                    console.log(e);
                })

        }

        this.$store.state.signedIn = false;
        this.$store.state.routeLoaded = true;
    },
    methods: {
        // newLogin switches the card to the registration form
        async showRegister() {
            this.loginError = false;
            this.newLogin = true;
            await this.getRegistrationForm();
        },
        showLogIn() {
            this.loginError = false;
            this.submitted = false;
            this.newLogin = false;
        },
        // Loads the company's locations and registration fields
        async getRegistrationForm() {
            if(!this.companyName) {
                return;
            }
            await axios.get(`${this.$store.state.apiUrl}/api/naregistrationform?companyName=${encodeURIComponent(this.companyName)}`)
                .then(resp => {
                    this.loginError = false;
                    this.locations = resp.data.locations;
                    this.location = this.locations[0];
                    this.newEmployeeData.AdditionalFieldsJSON = (resp.data.fields || []).filter((f: any) => {
                        return f.collectOnRegistration;
                    })
                })
                .catch(e => {
                    this.locations = [];
                    this.location = '';
                    this.newEmployeeData.AdditionalFieldsJSON = [];
                    this.loginErrorMessage = e?.response?.data || 'There was an error';
                    this.loginError = true;
                });
        },
        async submit() {
            if(!this.companyName || !this.phone) {
                return;
            }
            const phone = normalizePhone(this.phone);
            if(!phone) {
                this.loginErrorMessage = PHONE_ERROR;
                this.loginError = true;
                return;
            }

            this.submitted = true;
            this.loginError = false;

            await axios.post(`${this.$store.state.apiUrl}/api/nalogin`, { companyName: this.companyName, phone: phone, password: this.password})
                .catch(e => {
                    this.loginErrorMessage = e?.response?.data || 'There was an error';
                    this.loginError = true;
                    this.submitted = false;
                });

            if(this.loginError) {
                this.submitted = false;
                return;
            }

            // Edit App.vue as well
            await axios.get(`${this.$store.state.apiUrl}/api/session`)
                .then(resp => {
                    this.$store.state.user = resp.data;
                    localStorage.setItem('playbook_jwt', resp.data.jwt);
                    this.$store.state.signedIn = true;
                    this.$store.dispatch('setStoreData');
                    if(this.$route.query.redirect) {
                        this.$router.push(this.$route.query.redirect);
                    } else {
                        this.$router.push('/playbook/home');
                    }
                })
                .catch(e => {
                    this.loginErrorMessage = e?.response?.data || 'There was an error';
                    this.loginError = true;
                    this.submitted = false;
                });
        },
        async submitNew() {
            if(!this.companyName || !this.phone || !this.firstName || !this.lastName || !this.location || !this.newEmployeeData.Email) {
                alert('Fill in all fields');
                return;
            }

            const phone = normalizePhone(this.phone);
            if(!phone) {
                alert(PHONE_ERROR);
                return;
            }

            for(const field of this.newEmployeeData.AdditionalFieldsJSON) {
                if(!field.value && field.requiredOnRegistration) {
                    alert(`${field.name} is required`);
                    return;
                }
            }

            if(!this.newPassword || !this.newPasswordConfirm) {
                alert('A password is required');
                return;
            }
            if(this.newPassword != this.newPasswordConfirm) {
                alert('Passwords do not match');
                return;
            }

            this.submitted = true;
            this.loginError = false;

            await axios.post(`${this.$store.state.apiUrl}/api/naregister`, { companyName: this.companyName, phone: phone, firstName: this.firstName, lastName: this.lastName, location: this.location, employeeData: this.newEmployeeData, password: this.newPassword })
                .then(() => {
                    // Stays up with no close button so the form can't be submitted again
                    this.registrationSubmitted = true;
                })
                .catch(e => {
                    this.loginErrorMessage = e?.response?.data || 'There was an error';
                    this.loginError = true;
                    this.submitted = false;
                });
        },
        async submitPasswordReset() {
            if(!this.companyName || !this.phone) {
                return;
            }
            const phone = normalizePhone(this.phone);
            if(!phone) {
                alert(PHONE_ERROR);
                return;
            }

            const data = {
                companyName: this.companyName,
                phone: phone
            }
            await axios.post(`${this.$store.state.apiUrl}/api/resetpublicpassword`, data)
                .then(resp => {
                    alert('You should receive a text message shortly');
                    this.showPasswordReset = false;
                })
                .catch(e => {
                    alert('There was an error')
                });
        }
    }
})
</script>